import { HttpAdapter } from "../../../main/adapters/HttpAdapter";

export class HubSpot {
    HttpAdapter = new HttpAdapter();
    baseUrlAccounting = `${publicSettings.aws.baseUrls.accounting}/accounting`;

    constructor() {}

    async insert(accountingId) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlAccounting}/send-for-hubspot`,
            {
                accountingId
            }
        );
        return response;
    }
}
